import React from 'react';
import PropTypes from 'prop-types';

import KTitle from './KTitle';
import KAvatar from './KAvatar';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 36,
    marginBottom: 24,
  },
  title: {
    fontSize: 28,
  },
  avatar: {
    marginLeft: 12,
    marginRight: 12,
  },
};

const KHero = ({
  title, imgSrc, subtitle, masterId,
}) => (
  <div style={styles.container}>
    <KAvatar imgSrc={imgSrc} style={styles.avatar} masterId={masterId} />
    <KTitle subtitle={subtitle} title={title} style={styles.title} />
  </div>
);

KHero.propTypes = {
  title: PropTypes.node.isRequired,
  masterId: PropTypes.number,
  subtitle: PropTypes.node,
  imgSrc: PropTypes.string,
};

export default KHero;



// WEBPACK FOOTER //
// ./src/components/KJRN/KHero.js